<template>
  <div class="app agent-center-page">
    <div class="agent-header">
      <div class="header-top">
        <div class="back" @click="$router.back()">
          <i class="van-icon van-icon-arrow-left"></i>
        </div>
        <h1>{{ $t('Agent Center') }}</h1>
        <div class="header-right"></div>
      </div>
    </div>

    <div class="agent-nav" v-if="isAgent">
      <div
        v-for="(item, index) in navItems"
        :key="index"
        :class="['nav-item', { active: activeTab === index }]"
        @click="switchTab(index)"
      >
        {{ item.title }}
      </div>
    </div>

    <div class="agent-content" v-if="isAgent">
      <agent-dashboard v-if="activeTab === 0" />
      <agent-team v-if="activeTab === 1" />
      <agent-commission v-if="activeTab === 2" />
    </div>
  </div>
</template>
<script>
import AgentDashboard from './agent/agentDashboard.vue';
import AgentTeam from './agent/agentTeam.vue';
import AgentCommission from './agent/agentCommission.vue';

export default {
  name: 'agentCenter',
  components: {
    AgentDashboard,
    AgentTeam,
    AgentCommission,
  },
  data() {
    return {
      activeTab: 0,
      isAgent: false,
    };
  },
  computed: {
    navItems() {
      return [
        { title: this.$t('Agent Home') },
        { title: this.$t('Team Management') },
        { title: this.$t('Agent Report') },
      ];
    },
  },
  created() {
    this.loadStatus();
  },
  methods: {
    switchTab(index) {
      if (!this.isAgent && index > 0) {
        return;
      }
      this.activeTab = index;
    },
    loadStatus() {
      this.$apiFun.get('/api/agent/home').then((res) => {
        if (res && res.code === 200 && res.data) {
          this.isAgent = Number(res.data.is_agent) === 1;
          if (!this.isAgent) {
            this.$router.replace('/applyagent');
          }
        }
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-center-page {
  min-height: 100vh;
  background: #ffffff;
  color: #352b24;
}

.agent-header {
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
  color: #4a2e00;

  .header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;

    .back {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      i {
        font-size: 20px;
        color: #4a2e00;
      }
    }

    h1 {
      font-size: 18px;
      font-weight: bold;
      margin: 0;
    }

    .header-right {
      width: 40px;
    }
  }
}

.agent-nav {
  display: flex;
  background: #fff;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  box-shadow: 0 2px 5px rgba(117, 73, 34, 0.08);
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .nav-item {
    flex: 1;
    min-width: max-content;
    text-align: center;
    padding: 15px 10px;
    font-size: 14px;
    color: #8a6a4a;
    position: relative;

    &.active {
      color: #8f501f;
      font-weight: bold;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 2px;
        background: #d1a03e;
      }
    }
  }
}

.agent-content {
  background: #ffffff;
  min-height: calc(100vh - 120px);
}
</style>



// WEBPACK FOOTER //
// src/components/agentCenter.vue